// extracted by mini-css-extract-plugin
export default {"inputEnter":"input-box_inputEnter__LGOL9"};